/*jshint ignore:start*/

(function()
{
	function CharacterSelect()
	{
		this.View_constructor();

		this.idleAllowed = false;
		this.idleTimer = 0;
		this.idleCharacter = 'abby';


		var bg = new cjs.Bitmap(cm.Assets.lib.CharacterSelectBG);
		bg.center();

		this.charactersMC = new cm.Assets.lib.MainAnimsLib.mc_charselect();
		this.charactersMC.set({framerate: 30, "x":-510,"y":-330});
		this.charactersMC.gotoAndStop(0);

		// Set mouseChildren false so that no children of these two MCs are counted as the targets of the event handler.
		this.charactersMC.abby_btn.set({name: 'abby', mouseChildren: false}).gotoAndStop('up');
		this.charactersMC.elmo_btn.set({name: 'elmo', mouseChildren: false}).gotoAndStop('up');

		this.charactersMC.abby_btn.paperdoll.changeSnapToPixel(false);
		this.charactersMC.elmo_btn.paperdoll.changeSnapToPixel(false);

		this.abbyLipsyncContainer = this.charactersMC.abby_btn.paperdoll.getBodypartInstances('mc_abby_container_head')[0].lipsyncMouthContainer;
		this.elmoLipsyncContainer = this.charactersMC.elmo_btn.paperdoll.getBodypartInstances('mc_elmo_container_head')[0].lipsyncMouthContainer;


		this.addChild(
			bg,
			this.charactersMC
		);

		this.charactersMC.abby_btn.gotoAndStop('up');
		this.charactersMC.elmo_btn.gotoAndStop('up');

	}

	var p = createjs.extend(CharacterSelect, cm.View);


	p.start = function() 
	{

		this.musicLoop = cm.app.sound.play('DressUpMusic_02introLoop', {volume: 0, loop: true});
		cm.app.sound.fadeIn(this.musicLoop, 300, 0.3, 0);

		if (!cm.app.game.hasSeenCharSelect)
		{
			cm.app.game.hasSeenCharSelect = true;
			cjs.Tween.get(this)
				.wait(500)
				.call(this._introLipsync1, null, this);
		} 
		else 
		{
			this.allowIdle();
			this.idleTimer = 14500;
		}

		this.setActive(true);

	};


	p.onQuitGame = function() 
	{
		cm.analytics.quitGame(
			'Home Screen'
		);
	};

	p._introLipsync1 = function() 
	{
		this.elmoLipsyncContainer.playLipsync('e_charselect_intro1', this._introLipsync2.bind(this));
	};

	p._introLipsync2 = function() 
	{
		this.abbyLipsyncContainer.playLipsync('a_charselect_intro2', this._introLipsync3.bind(this));
	};

	p._introLipsync3 = function() 
	{
		this.elmoLipsyncContainer.playLipsync('e_charselect_intro3', this._introLipsync4.bind(this));
	};

	p._introLipsync4 = function() 
	{
		this.abbyLipsyncContainer.playLipsync('a_charselect_intro4', this.allowIdle.bind(this));
	};

	p.allowIdle = function() 
	{
		this.idleTimer = 0;
		this.idleAllowed = true;
	};


	p.setActive = function(active) 
	{
		if (active === true) 
		{
			this.on('mouseover', this.handleInteraction, this);
			this.on('mouseout', this.handleInteraction, this);
			this.on('click', this.handleInteraction, this);
		} 
		else 
		{
			this.removeAllEventListeners();
			cjs.Tween.removeTweens(this);
		}
	};

	p.destroy = function() 
	{
		this.View_destroy();
		cm.app.sound.fadeOut(this.musicLoop);
	};


	p.handleInteraction = function(e) 
	{

		if (e.target.name === 'elmo' || e.target.name === 'abby') 
		{
			switch(e.type) 
			{
				case 'mouseover':
					cm.app.game.hoverCursor();
					cm.app.sound.play('ro4', {volume: 0.4});
					e.target.gotoAndStop('over');
					break;
				case 'mouseout':
					cm.app.game.unhoverCursor();
					e.target.gotoAndStop('up');
					break;
				case 'click':
					cm.app.voPlayer.stop();
					this.abbyLipsyncContainer.stopLipsync();
					this.elmoLipsyncContainer.stopLipsync();
					cm.analytics.event('CharacterSelection', e.target.name, null);
					cm.game.gotoChallenge(e.target.name);
					break;
			}		
		}

	};

	p.onUserReEngage = function() 
	{
		cm.analytics.userReengage('Home Screen');
	};

	p.update = function(deltaT)
	{
		if (this.idleAllowed)	
		{
			this.idleTimer += deltaT;
		
			if (this.idleTimer > 15000)
			{
				this.idleTimer = 0;

				cm.analytics.timeoutFired('Home Screen');

				if (this.idleCharacter === 'abby')
				{
					this.idleCharacter = 'elmo';
					this.abbyLipsyncContainer.playLipsync('a_charselect_idle1');
				}
				else
				{
					this.idleCharacter = 'abby';
					this.elmoLipsyncContainer.playLipsync('e_charselect_idle2');
				}
			}

		}
	};


	cm.View.CharacterSelect = cjs.promote(CharacterSelect, "View");

})();

/*jshint ignore:end*/